import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';

import { FlightEvent } from 'ff/debrief/models';
import InstrumentApproachIcon from 'ff/debrief/components/customIcons/InstrumentApproachIcon';
import SentryPlusIcon from 'ff/debrief/components/customIcons/SentryPlusIcon';
import LandingIcon from 'ff/debrief/components/customIcons/LandingIcon';

interface Props {
    events: FlightEvent[];
}

const FlightEvents: React.FC<Props> = props => {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="start"
            spacing={2}
        >
            {props.events.map(fe => {
                return <FlightEventBadge key={fe.eventType} flightEvent={fe} />;
            })}
        </Stack>
    );
};

interface FlightEventProps {
    flightEvent: FlightEvent;
}
const SmallAvatar = styled(Avatar)(() => ({
    width: 'auto',
    height: 16,
    fontSize: '11px',
    padding: '2px 6px',
    borderRadius: '11px',
    backgroundColor: '#1E374F',
}));

const FlightEventBadge: React.FC<FlightEventProps> = props => {
    const { flightEvent } = props;
    const ICON_FONT_SIZE = '2.2rem';
    const icon = React.useMemo(() => {
        switch (flightEvent.eventType) {
            case 'landings':
                return <LandingIcon sx={{ fontSize: ICON_FONT_SIZE }} />;
            case 'iap':
                return (
                    <InstrumentApproachIcon sx={{ fontSize: ICON_FONT_SIZE }} />
                );
            case 'sentry':
                return <SentryPlusIcon sx={{ fontSize: ICON_FONT_SIZE }} />;
            default:
                return null;
        }
    }, [flightEvent]);

    if (!icon) {
        return null;
    }

    return (
        <Stack alignItems="center">
            <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                badgeContent={
                    flightEvent?.count > 0 ? (
                        <SmallAvatar>{flightEvent?.count}</SmallAvatar>
                    ) : (
                        0
                    )
                }
                showZero={false}
            >
                <Avatar
                    sx={{
                        height: '40px',
                        width: '40px',
                        margin: '4px 4px',
                        backgroundColor: '#DFE3E6',
                    }}
                >
                    {icon}
                </Avatar>
            </Badge>
            <Typography fontSize="10px">{flightEvent?.userText}</Typography>
        </Stack>
    );
};

export default FlightEvents;
